"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _util = require("../util");

var _dsCore = require("@irim/ds-core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const SOCKET = Symbol('SocketConnect.socket');
const MESSAGE_HANDLER = Symbol('SocketConnect.messageHandler');
const BIND_MESSAGE_EVENT = Symbol('SocketConnect.bindMessageEvent');
const READY_STATE_MAPPING = ['CONNECTING', 'OPEN', 'CLOSING', 'CLOSED'];

class Socket {
  /** @type WebSocket */

  /** @type Function[] */

  /**
   * @typedef {object} PropsObject
   * @property {string} url connect url
   * @property {string|string[]} [protocols] websocket protocol
   * @property {number} [timeout=20000] timeout of connect websocket
   * @property {'json'|'text'|'blob'} [dataType='json'] response message type
   * @property {'sync'|'async'} [callbackType] callback function type
   */

  /** @type PropsObject */

  /**
   * @param {PropsObject} props
   */
  constructor(props) {
    this[SOCKET] = {};
    this[MESSAGE_HANDLER] = [];
    this.props = {};
    this.props = _objectSpread({
      timeout: 20000,
      dataType: 'json',
      callbackType: 'sync'
    }, props);
  }

  get readyState() {
    return this[SOCKET].readyState;
  }
  /**
   * @return {'CONNECTING'|'OPEN'|'CLOSING'|'CLOSED'|'UNKNOWN'}
   */


  get readyStateName() {
    return READY_STATE_MAPPING[this.readyState] || 'UNKNOWN';
  }

  get binaryType() {
    return this[SOCKET].binaryType;
  }

  get protocol() {
    return this[SOCKET].protocol;
  }

  get extensions() {
    return this[SOCKET].extensions;
  }

  get bufferedAmount() {
    return this[SOCKET].bufferedAmount;
  }

  open(timeout = this.props.timeout) {
    return new Promise((resolve, reject) => {
      let timmer = null;
      const start = performance.now();

      _dsCore.logger.debug("Connecting ".concat(this.props.url, " ..."));

      this[SOCKET] = new WebSocket(this.props.url, this.props.protocols);

      this[SOCKET].onopen = e => {
        _dsCore.logger.success("Connected ".concat(this.props.url), performance.now() - start);

        timmer && clearTimeout(timmer);
        this[BIND_MESSAGE_EVENT]();
        resolve(this);
      };

      this[SOCKET].onerror = e => {
        _dsCore.logger.warn("Connecting Error: ".concat(this.props.url), e);

        timmer && clearTimeout(timmer);
        reject(e);
      };

      timmer = setTimeout(() => {
        _dsCore.logger.warn("Connecting Timeout: ".concat(this.props.url));

        this[SOCKET].onopen = this[SOCKET].onerror = null;
        reject(new Error('Connect Timeout'));
        timmer = null;
      }, timeout);
    });
  }

  close() {
    return new Promise((resolve, reject) => {
      this[SOCKET].close();

      this[SOCKET].onclose = e => {
        _dsCore.logger.debug("Connect closed. ".concat(this.props.url));

        this.clear();
        resolve(e);
      };

      this[SOCKET].onerror = e => {
        _dsCore.logger.warn("Connecting close failed: ".concat(this.props.url), e);

        reject(e);
      };
    });
  }

  async reconnect() {
    await this.close();
    return await this.open();
  }
  /**
   * @param {string} message
   */


  postMessage(message) {
    if (typeof message !== 'string') {
      throw new TypeError('message must be a string.');
    }

    this[SOCKET].postMessage(message);
  }
  /**
   * @param {string} message
   */


  sendMessage(message) {
    const content = typeof message === 'string' ? message : JSON.stringify(message);
    this[SOCKET].send(content);
  }
  /** alias for postMessage */


  sendString(str) {
    return this.postMessage(str);
  }
  /**
   * @param {Blob} blob
   */


  sendBlob(blob) {
    this[SOCKET].send(blob);
  }
  /**
   * @param {ArrayBuffer|SharedArrayBuffer|ArrayBufferView} buffer
   */


  sendArrayBuffer(buffer) {
    this[SOCKET].send(buffer);
  }
  /**
   * @param {'message'|'close'|'error'|'open'} eventName
   * @param {Function} callback
   * @return {Function} off event function
   */


  on(eventName, callback) {
    this[SOCKET].addEventListener(eventName, callback);
    return () => this[SOCKET].removeEventListener(eventName, callback);
  }

  onMessage(callback) {
    if (typeof callback !== 'function') {
      throw new TypeError('callback must be a function');
    }

    this[MESSAGE_HANDLER].push(callback);
    return () => {
      const index = this[MESSAGE_HANDLER].findIndex(callback);
      this[MESSAGE_HANDLER].splice(index, 1);
    };
  }

  [BIND_MESSAGE_EVENT]() {
    this[SOCKET].onmessage = e => {
      let data = e.data;

      if (this.props.dataType === 'json') {
        data = (0, _util.parseJSON)(data);
      }

      if (this.props.callbackType === 'sync') {
        (0, _dsCore.batchExecSync)(this[MESSAGE_HANDLER], [data], this);
      } else {
        (0, _dsCore.batchExecAsync)(this[MESSAGE_HANDLER], [data], this);
      }
    };
  }

  clear() {
    this[MESSAGE_HANDLER] = [];
  }

}

exports.default = Socket;
Socket.CONNECTING = WebSocket.CONNECTING;
Socket.OPEN = WebSocket.OPEN;
Socket.CLOSING = WebSocket.CLOSING;
Socket.CLOSED = WebSocket.CLOSED;